import React from 'react'
import Sidebar from '../components/sidebar'
import Header from '../components/Header'
import AddSliderMain from '../components/sliders/AddSliderMain'

const AddSlider = () => {
    return (
        <>
            <Sidebar />
            <main className="main-wrap">
                <Header />
                <AddSliderMain/>
            </main>
        </>
    )
}

export default AddSlider